import {
  DEFAULT_LOCALE,
  LOCALE_COOKIE_NAME,
  isSupportedLocale,
  pickLocaleFromAcceptLanguage,
  type SupportedLocale,
} from '@/i18n/config';

/** Read the `NEXT_LOCALE` cookie value (non-HttpOnly, set by the locale toggle). */
function readLocaleCookie(): string | undefined {
  if (typeof document === 'undefined') return undefined;
  const match = document.cookie
    .split(';')
    .map((c) => c.trim())
    .find((c) => c.startsWith(`${LOCALE_COOKIE_NAME}=`));
  return match ? decodeURIComponent(match.slice(LOCALE_COOKIE_NAME.length + 1)) : undefined;
}

/**
 * Client-side locale resolution, replacing the former server `getRequestConfig`
 * + `proxy.ts` cookie materialization. Priority:
 *   1. `NEXT_LOCALE` cookie
 *   2. `navigator.language(s)`
 *   3. `DEFAULT_LOCALE` (`de-DE`)
 */
export function resolveInitialLocale(): SupportedLocale {
  const cookie = readLocaleCookie();
  if (isSupportedLocale(cookie)) return cookie;

  if (typeof navigator !== 'undefined') {
    const header = (
      navigator.languages?.length ? navigator.languages.join(',') : navigator.language
    ) as string | undefined;
    if (header) return pickLocaleFromAcceptLanguage(header);
  }

  return DEFAULT_LOCALE;
}
